import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";
import { CheckoutSheet } from "@/components/site/CheckoutSheet";

const StoreCtx = createContext({ stock: null, initial: 25, openCheckout: () => {}, refresh: () => {} });

export const StoreProvider = ({ children }) => {
  const [stock, setStock] = useState(null);
  const [initial, setInitial] = useState(25);
  const [open, setOpen] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await http.get("/inventory");
      setStock(typeof data?.stock === "number" ? data.stock : null);
      setInitial(data?.initial ?? 25);
    } catch {
      setStock(null);
    }
  }, []);

  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 30000);
    return () => clearInterval(t);
  }, [refresh]);

  const openCheckout = useCallback(() => setOpen(true), []);

  return (
    <StoreCtx.Provider value={{ stock, initial, openCheckout, refresh }}>
      {children}
      <CheckoutSheet open={open} onOpenChange={setOpen} stock={stock} />
    </StoreCtx.Provider>
  );
};

export const useStore = () => useContext(StoreCtx);
